import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../lib/msalConfig'
import styles from './LoginPage.module.css'

export default function LoginPage() {
  const { instance } = useMsal()

  function handleLogin() {
    instance.loginRedirect(loginRequest)
  }

  return (
    <div className={styles.page}>
      <div className={styles.blob} />
      <div className={styles.card}>
        <img src="/brambles-logo.png" alt="Brambles" className={styles.logo} />
        <p className={styles.tagline}>Internal link shortener for Brambles teams.</p>
        <p className={styles.hint}>Sign in with your Brambles Microsoft account to continue.</p>
        <button className={styles.signInBtn} onClick={handleLogin}>
          <svg className={styles.msIcon} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Sign in with Microsoft
        </button>
      </div>
      <footer className={styles.footer}>
        <span>© 2025 Brambles — Internal Tool</span>
      </footer>
    </div>
  )
}
